export default {
  language: {
    pt: 'PT',
    en: 'EN',
  },
  header: {
    home: 'Home',
    howItWorks: 'How It Works',
    experiences: 'Experiences',
    contact: 'Contact',
    dashboard: 'My Dashboard',
    account: 'Account',
    login: 'Sign In',
    generateFull: 'Create Travel Itinerary',
    generateShort: 'Itinerary',
  },
  hero: {
    eyebrow: 'Travel Intelligence Platform',
    titleLine1: 'Travel Planning',
    titleLine2: 'Powered by',
    titleLine3: 'Intelligence',
    sub1: 'Strategic AI to create.',
    sub2: 'Specialists to refine.',
    sub3: 'You to live it.',
    create: 'Create My Itinerary',
    dashboard: 'My Dashboard',
    login: 'Sign in to my account',
    howItWorks: 'See How It Works',
    stats: {
      planning: 'Smart Planning',
      specialized: 'Specialized',
      support: 'Personalized',
    },
  },
  loading: {
    title: 'Creating your itinerary...',
    subtitle: 'This may take a few seconds',
    tip: 'We are personalizing every detail based on your profile',
    messages: [
      'Analyzing your traveler profile...',
      'Selecting ideal destinations...',
      'Optimizing the travel flow...',
      'Personalizing the experiences...',
      'Calculating an estimated investment...',
      'Adjusting the travel rhythm...',
      'Adding local recommendations...',
      'Finalizing your premium itinerary...',
    ],
  },
  wizard: {
    nav: {
      back: 'Back',
      next: 'Next',
      generate: 'Generate Itinerary',
      stepCounter: '{{current}} of {{total}}',
      progressComplete: 'complete',
    },
    steps: {
      1: { title: 'Your Profile', description: 'Tell us a bit about yourself' },
      2: { title: 'Travel Style', description: 'How do you like to travel?' },
      3: { title: 'World Regions', description: 'Which regions interest you?' },
      4: { title: 'Travel Rhythm', description: 'What pace feels ideal to you?' },
      5: { title: 'Time Preference', description: 'When do you prefer doing activities?' },
      6: { title: 'Previous Trips', description: 'Where have you already been?' },
      7: { title: 'Must-Do Experiences', description: 'What cannot be missing from this trip?' },
      8: { title: 'Experiences to Avoid', description: 'What would you rather avoid?' },
      9: { title: 'Special Needs', description: 'Anything we should know?' },
      10: { title: 'Your Details', description: 'Final step — we will send your itinerary here' },
    },
    step10: {
      modeTitle: 'How would you like to define the destination for this trip?',
      modeDescription:
        'We can continue with the destination you already have in mind or suggest options that match your profile before generating the itinerary.',
      manualTitle: 'I already know my destination',
      manualDescription: 'Continue with the current flow and generate the itinerary for the destination you choose.',
      suggestedTitle: 'I want personalized suggestions',
      suggestedDescription: 'We assemble suggestions based on your style, preferred regions and budget range.',
      departureCity: 'Departure City',
      destination: 'Destination',
      destinationSuggested: 'Suggested destination',
      destinationSuggestedDescription:
        'Choose one of the suggestions below. Once selected, we continue with the normal itinerary creation flow.',
      suggestionsTitleOne: '1 destination compatible with your profile',
      suggestionsTitleOther: '{{count}} destinations compatible with your profile',
      suggestionsDescription: 'Based on style, selected regions, budget and previous travel history.',
      selectedSuffix: 'selected',
      useDestination: 'Use destination',
      selected: 'Selected',
      recommendedFor: 'Recommended for {{styles}}',
      whyRecommended: 'Why we recommend this destination',
      compatibility: 'Compatibility reading',
      weightedSignals: 'Signals that mattered',
      continueDescription: 'When you continue, we proceed normally with itinerary generation and passport creation.',
      noSuggestionTitle: 'We do not have a ready suggestion for this combination yet',
      noSuggestionDescription:
        'To keep the recommendation coherent with the region you selected, we prefer not to mix continents here. If you already have a destination in mind, switch back to the manual flow and continue normally.',
      backToManual: 'I already know my destination',
    },
  },
  result: {
    headerBrand: 'Aero Destiny Travel',
    contactConsultant: 'Talk to a Consultant',
    errorTitle: 'Oops! Something went wrong',
    retry: 'Try Again',
    support: 'Talk to Support',
    successBadge: 'Itinerary generated successfully',
    passportOpening: 'Opening your Aero Passport shortly...',
    heroTitlePrefix: 'Your Itinerary for',
    heroSubtitle: '{{days}} days of exclusive experiences for {{people}} traveler{{suffix}} — style {{style}}',
    specialistNow: 'Talk to a Specialist Now',
    profileTitle: 'Profile: {{name}}',
    profileSubtitle: 'Itinerary tailored to your travel style',
    cards: {
      destination: 'Destination',
      style: 'Style',
      travelers: 'Travelers',
      duration: 'Duration',
      investment: 'Investment',
    },
    profileTipsTitle: 'Exclusive Tips for {{style}}',
    profileTipsSubtitle: 'Suggestions tailored to your traveler profile',
    hiddenGemBadge: 'Exclusive Tip — Hidden Gem',
    hiddenGemTitle: 'A Less Obvious Experience in {{destination}}',
    destinationInfoTitle: 'Information about {{destination}}',
    destinationInfo: {
      climate: 'Climate',
      currency: 'Currency',
      language: 'Language',
      bestMonths: 'Best Time to Go',
      timeZone: 'Time Zone',
      visa: 'Visa',
      vaccines: 'Vaccines',
    },
    hotelTitle: 'Recommended Hotel',
    itineraryBadge: 'Day-by-Day Itinerary',
  },
  auth: {
    login: {
      title: 'Aero Passport',
      subtitle: 'Your trips and travel memories in one account. Enter your email to sign in or create an account with a one-time code. No password needed.',
      flightFollowTitle: 'Confirm this flight follow',
      flightFollowSubtitle:
        'Sign in first so we can connect this shared flight invite to your account and bring you back to the trip.',
      flightFollowCardTitle: 'This is a follow invite, not a generic login',
      flightFollowCardBody:
        'After sign-in, you will return to the shared trip and confirm that you want to follow these flights.',
      emailLabel: 'Your email',
      emailPlaceholder: 'you@email.com',
      submit: 'Email me a code',
      cooldownButton: 'Wait {{seconds}}s',
      sending: 'Sending...',
      success: 'Check your inbox for the latest code, then enter it below to continue.',
      successFollow:
        'Check your inbox for the latest code. Enter it below to confirm this flight follow invite.',
      otpLabel: 'One-time email code',
      otpPlaceholder: '00000000',
      otpSubmit: 'Confirm code',
      otpVerifying: 'Confirming...',
      otpHelper: 'Use the latest code from your email. You can stay on this screen while checking your inbox.',
      helper: 'New here? Verifying your email creates your account automatically. No separate registration or password.',
      flightFollowHelper:
        'The follow invite stays attached to this route. Sign in once, return, and then confirm the invite.',
      cooldownHint:
        'Access was requested recently. Wait {{seconds}} seconds before trying again. If you already received the latest email, use its code.',
      errors: {
        supabaseMissing: 'Supabase is not configured.',
        missingEmail: 'Enter your email.',
        invalidEmail: 'Enter a valid email address.',
        rateLimit:
          'Too many access requests were sent. Wait about {{seconds}} seconds, then try again. If you already received an email, use the latest code.',
        cooldownActive:
          'Access was already requested recently. Wait {{seconds}} seconds before sending another one.',
        missingOtp: 'Enter the code from the email.',
        invalidOtp: 'The code is invalid or expired. Request a new login email and try again.',
        generic: 'Could not send the access email.',
      },
    },
    callback: {
      title: 'Aero Passport App',
      flightFollowTitle: 'Confirming your flight follow access',
      default: 'Confirming your access...',
      flightFollow: 'Confirming your access and bringing you back to the shared flight invite...',
    },
  },
  dashboard: {
    hero: {
      eyebrow: 'Aero Passport App',
      welcome: 'Welcome back, {{name}}',
      subtitle:
        'Your trips, itineraries and experiences live here in one place. Each passport records a new chapter of your journey.',
      connectedAs: 'Signed in as',
      archiveCountOne: '{{count}} passport in your archive',
      archiveCountOther: '{{count}} passports in your archive',
      helper: 'Open a trip, resume an itinerary or start a new experience whenever you want.',
    },
    actions: {
      createTrip: 'Create new trip',
      logout: 'Sign out',
      openPassport: 'Open passport',
    },
    stats: {
      totalPassports: 'Total passports',
      activeTrips: 'Active trips',
      completedTrips: 'Completed',
      templates: 'Reusable bases',
      shared: 'Shared guides',
    },
    loading: 'Loading trips...',
    empty: {
      title: 'Your archive starts here',
      description:
        'Create your first trip and turn every itinerary into an Aero Passport you can consult, revisit and share.',
    },
    disclosure: {
      open: 'Open',
      hide: 'Hide',
    },
    visibility: {
      public: 'Public',
      shared: 'Shared',
    },
    archive: {
      travelersOne: '{{count}} traveler',
      travelersOther: '{{count}} travelers',
      createdOn: 'Created on',
      activating: 'Activating...',
      activateTemplate: 'Activate base',
      activateShared: 'Activate guide',
      creating: 'Creating...',
      useBase: 'Use base',
      copyLink: 'Copy link',
      openShared: 'Open guide',
    },
    mobile: {
      intelligence: {
        title: 'Best next move',
        badge: 'Suggestions for now',
        summary:
          'Based on your trips, the dashboard highlights what is most worth revisiting, sharing or closing now.',
      },
      collection: {
        title: 'Guides and bases',
        badge: 'Living library',
        summary:
          '{{shared}} guides and {{templates}} bases can already be shared or reused more effectively.',
      },
    },
    status: {
      created: 'Under review',
      iddasCreated: 'Ready for proposal',
      iddasFailed: 'Waiting for specialist',
      planning: 'Planning',
      quotationRequested: 'Quote requested',
      confirmed: 'Confirmed',
      traveling: 'Traveling',
      completed: 'Completed',
    },
    continueTrip: {
      traveling: {
        eyebrow: 'Your trip is in progress',
        title: 'Everything is ready to use during the journey',
        subtitle:
          'Open your passport quickly and check the trip details whenever you need them.',
      },
      confirmed: {
        eyebrow: 'Prepare your next trip',
        title: 'Your passport is ready to guide the next steps',
        subtitle:
          'Review the trip details and keep everything close before departure.',
      },
      planning: {
        eyebrow: 'Keep planning your trip',
        title: 'Your itinerary is already taking shape',
        subtitle:
          'Resume the planning, review the details and keep building the experience.',
      },
      quotationRequested: {
        eyebrow: 'Your proposal is moving forward',
        title: 'Your passport follows the trip’s evolution',
        subtitle: 'Track the progress and come back whenever you want to review the itinerary.',
      },
      iddasCreated: {
        eyebrow: 'Your proposal is moving forward',
        title: 'Your passport is already part of the next step',
        subtitle: 'Now is a good time to review the details and keep an eye on the trip.',
      },
      created: {
        eyebrow: 'Your itinerary has been created',
        title: 'Your next trip already has a starting point',
        subtitle: 'Open the passport to review the destination, proposal and next steps.',
      },
      iddasFailed: {
        eyebrow: 'Finish it with a specialist',
        title: 'Your itinerary is ready to be refined',
        subtitle:
          'Review the passport and move forward with human support to turn the plan into a real trip.',
      },
      completed: {
        eyebrow: 'Relive your last trip',
        title: 'Your passport still keeps this journey alive',
        subtitle:
          'Come back whenever you want to revisit the details and keep your archive alive.',
      },
      default: {
        eyebrow: 'Continue your trip',
        title: 'Your passport is ready for you',
        subtitle: 'Open the trip and continue where you left off.',
      },
    },
  },
  homeSections: {
    howItWorks: {
      badge: 'Consulting Process',
      titleBefore: 'How the',
      titleHighlight: 'Itinerary Generator',
      titleAfter: 'Works',
      description:
        'From your idea to a complete itinerary in 4 simple steps. Advanced technology and human consulting working together to create your dream trip.',
      cta: 'Generate My Itinerary Now',
      steps: {
        1: {
          title: 'Tell Us Your Destination',
          description:
            'Choose where you want to go, your dates, number of travelers and the style of your trip. Simple and fast.',
        },
        2: {
          title: 'Personalize Preferences',
          description:
            'Set your budget, experience level and preferred hotel. The more detail you share, the better the outcome.',
        },
        3: {
          title: 'AI Builds Your Itinerary',
          description:
            'Our artificial intelligence creates a real day-by-day itinerary with exclusive experiences selected for your profile.',
        },
        4: {
          title: 'A Consultant Refines Everything',
          description:
            'A specialized Travel Strategist gets in touch to refine details, search rates and guarantee the ideal trip.',
        },
      },
    },
    contact: {
      badge: 'Smart Travel Consultant',
      titleLine1: 'Not sure where to go?',
      titleLine2: 'We plan it for you.',
      description:
        'Our AI analyzes your profile, budget and lifestyle to create an itinerary suggestion made exclusively for you — not a template, but a journey designed from start to finish.',
      highlights: {
        profile: 'AI analyzes your profile',
        itinerary: 'Real day-by-day itinerary',
        speed: 'Results in seconds',
        security: 'Protected data',
      },
      qrHint: 'Point your camera',
      directTitle: 'Prefer to talk directly?',
      directDescription:
        'Scan the QR code or tap the button to speak with our premium travel consultants on WhatsApp.',
      whatsappCta: 'Open WhatsApp',
    },
    premium: {
      badge: 'Curated ideas',
      titleLine1: 'Travel ideas curated',
      titleLine2: 'by Aero Destiny',
      description:
        'Explore starting points for meaningful trips. Our team refines routes, hotels, logistics and experiences around your profile.',
      cta: 'Start my itinerary review',
      customCardTitleLine1: 'Tailor-Made',
      customCardTitleLine2: 'Travel Design',
      customCardDescription:
        'Did not find exactly what you want? Start with your destination and our team will refine the route, hotels and travel flow.',
      customCardCta: 'Start my itinerary review',
      pricePrefix: 'Defined after review',
      processTitle: 'How an idea becomes a real trip',
      process: {
        1: {
          title: '1. Initial direction',
          description:
            'You choose an idea or start from scratch to guide the travel design.',
        },
        2: {
          title: '2. Consultant review',
          description:
            'Aero Destiny reviews route, hotels, logistics and pacing before turning the idea into a proposal.',
        },
        3: {
          title: '3. Executable itinerary',
          description:
            'The final result prioritizes clarity, human support and a trip that can actually be executed.',
        },
      },
      cards: {
        safari: {
          category: 'NATURE & CULTURE',
          title: 'Kenya Safari & Conservation Journey',
          description:
            'Wildlife, lodge direction and local guiding paced around reserves and conservation.',
          investment: 'Investment defined after consultant review',
          amenityLabels: ['Wildlife', 'Lodge direction', 'Local guide'],
        },
        cruise: {
          category: 'FOOD & ROUTING',
          title: 'Paris, Champagne & Loire',
          description:
            'City, gastronomy, wine country and refined routing without unnecessary movement.',
          investment: 'Investment defined after consultant review',
          amenityLabels: ['Paris', 'Champagne', 'Loire Valley'],
        },
        bali: {
          category: 'ROMANTIC RETREAT',
          title: 'Maldives Island Escape',
          description:
            'Resort rhythm, reef access, transfers and rest days shaped to keep the trip effortless.',
          investment: 'Investment defined after consultant review',
          amenityLabels: ['Reef', 'Transfers', 'Resort rhythm'],
        },
        japan: {
          category: 'CURATED ROUTE',
          title: 'Japan Golden Route',
          description:
            'Tokyo, Kyoto and Osaka with culture, well-positioned hotels and thoughtful rail logistics.',
          investment: 'Investment defined after consultant review',
          amenityLabels: ['Tokyo', 'Kyoto', 'Rail logistics'],
        },
        patagonia: {
          category: 'ADVENTURE ROUTE',
          title: 'Lençóis Maranhenses Adventure',
          description:
            'Lagoons, crossings, smart bases and local logistics for a nature-led trip with better pacing.',
          investment: 'Investment defined after consultant review',
          amenityLabels: ['Lagoons', 'Crossings', 'Local logistics'],
        },
      },
    },
    footer: {
      brandDescription:
        'Premium strategic travel consulting. We transform dreams into exclusive and unforgettable experiences for demanding travelers.',
      paymentTitle: 'Payment Methods',
      navigationTitle: 'Navigation',
      contactTitle: 'Contact',
      socialTitle: 'Social Media',
      location: 'Goiânia, GO - Brazil',
      rights: '© 2026 Aero Destiny Travel. All rights reserved.',
    },
    missionVision: {
      badge: 'Who We Are',
      titleBefore: 'Our',
      titleHighlight: 'Essence',
      description:
        'Every trip we plan carries our deepest values — because we believe travel is one of the most powerful ways to transform lives.',
      imageAlt: 'Aero Destiny Travel - Our Vision',
      imageTitleBefore: 'Turning Dreams into',
      imageTitleHighlight: 'Real Destinations',
      cards: {
        mission: {
          label: 'MISSION',
          text: 'To share our travel knowledge and experience, both in Brazil and abroad, in order to create unique and enriching itineraries.',
        },
        vision: {
          label: 'VISION',
          text: 'To be recognized as an innovative and inspiring travel agency, a reference in transformative experiences.',
        },
        values: {
          label: 'VALUES',
          text: 'Curiosity and adventure; expertise and quality; personalization and empathy; innovation and inspiration; respect and sustainability; trust and honesty.',
        },
      },
    },
  },
};
